import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { RulerProgress } from '@/components/generals/ruler-progress'

export const Layout: FC<LayoutProps> = ({ children, header = 'dark' }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a href='#main' className='skip-link'>
                Hopp til innholdet
            </a>

            <Header initialScheme={header} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
            <RulerProgress />
        </div>
    )
}
